
import React, {useState, useEffect} from 'react';

import GLOBALS from '../elements/Globals';
import Loader from './Loader';
import img5 from './img/ylogo.png'
import { Link } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import Lightbox from 'bs5-lightbox';

import $ from 'jquery';

const createMarkup = (htmlString) => {
  return { __html: htmlString };
};

const Comments = (props) => {

  ReactSession.setStoreType("localStorage");

  const [loading, setLoading] = useState(false);
  const [pagedata, setPagedata ]= useState("");
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [returnmessage, setReturnmessage] = useState('');
  const [messagedata, setMessagedata ]= useState([]);

  useEffect(() => {
    var loggedin = ReactSession.get("loggedin");
    if(loggedin == 1){
      $('#comment_box').show();
      $('#before_comment_box').hide();
      var user = ReactSession.get("user");
      $('#user_id').val(user[0].user_id);
    }else{
      $('#comment_box').hide();
      $('#before_comment_box').show();
    }
  },[])

  const closeModal = () => {
    $('#modalClose').trigger('click');
  }

  const initiateComments = () => {
    loadMessages();
  }

  $(document).on("click",".comment-btn",function(event) {
    event.stopImmediatePropagation();
    let title = $(this).attr('data-title');
    let id = $(this).attr('data-id');
    let comment_type = $(this).attr('data-comment-type');
    $('#comment_top_heading').text(title);
    $('#news_id').val(id);
    $('#news_type').val(comment_type);
    $('#comment_type').val('news');
    $('#comment_success_message').text('');
    $('#openCommentBox').trigger('click');
    $('#initializeComment').trigger('click');
  })

  $(document).on("click",".like-positive",function(event) {
    event.stopImmediatePropagation();
    let id = $(this).attr('data-id');
    var user = ReactSession.get("user");
    setLoading(true)
    let apiUrl = 'likecomment';
    const url = GLOBALS.API_BASE_URL+apiUrl;
    try {
      $.ajax({
        type: "GET",
        url: url,
        data: 'id='+id+'&user_id='+user[0].user_id,
        cache: false,
        success: function(data){
           if(data.status == 1){
            $('#beforerate'+id).css('display','none');
            $('#afterrate'+id).css('display','flex');
            $('#afterrate'+id).find('.voto_positivo').text(data.message.like_count);
            $('#afterrate'+id).find('.voto_negativo').text(data.message.dislike_count);
            setLoading(false)
           }
        }
      });
    } catch (error) {
      console.error(error.message);
    }
});

$(document).on("click",".like-negative",function(event) {
  event.stopImmediatePropagation();
  let id = $(this).attr('data-id');
  var user = ReactSession.get("user");
  setLoading(true)
  let apiUrl = 'dislikecomment';
  const url = GLOBALS.API_BASE_URL+apiUrl;
  try {
    $.ajax({
      type: "GET",
      url: url,
      data: 'id='+id+'&user_id='+user[0].user_id,
      cache: false,
      success: function(data){
         if(data.status == 1){
          $('#beforerate'+id).css('display','none');
          $('#afterrate'+id).css('display','flex');
          $('#afterrate'+id).find('.voto_positivo').text(data.message.like_count);
          $('#afterrate'+id).find('.voto_negativo').text(data.message.dislike_count);
          setLoading(false)
         }
      }
    });
  } catch (error) {
    console.error(error.message);
  }
});

  // Event handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };

  async function sendForm() {
    setLoading(true)
    let apiUrl = 'commentpost';
    const url = GLOBALS.API_BASE_URL+apiUrl;
    try {

      $.ajax({
        type: "POST",
        url: url,
        data: 'message='+$('#comment_input').val()+'&news_id='+$('#news_id').val()+'&news_type='+$('#news_type').val()+'&comment_type='+$('#comment_type').val()+'&user_id='+$('#user_id').val(),
        cache: false,
        success: function(data){
           if(data.status == 1){
            $('#comment_success_message').text(data.message);
            $('#comment_input').val('');
            setLoading(false)
            loadMessages();
           }
        }
      });
    } catch (error) {
      console.error(error.message);
    }
    }

    function loadMessages()
    {
      setLoading(true)
      let apiUrl = 'getcomments';
      const url = GLOBALS.API_BASE_URL+apiUrl;
      try {
        $.ajax({
          type: "GET",
          url: url,
          data: 'id='+$('#news_id').val(),
          cache: false,
          success: function(data){
            if(data.status == 1){
              let messages = data.messages;
              setMessagedata(messages);
              setLoading(false)
            }
          }
        });
      } catch (error) {
        console.error(error.message);
      }
    }
  
    // Event handler for form submission
    const handleSubmit = (event) => {
      event.preventDefault();
  
      sendForm();
  
      setEmail('');
      setPassword('');
    };
  
  return (
    <div>
<button id='openCommentBox' type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#rightModal">
Comments
</button>
{/* Modal */}
<div className="modal fade right-modal" id="rightModal" tabIndex={-1} aria-labelledby="rightModalLabel" aria-hidden="true">
<div className="modal-dialog modal-dialog-slide modal-dialog-right">

  <div className="modal-content">
    <div className='modal-header-section'>
      <div className='modal-header-left'>
        <p id='comment_top_heading'>
        The forgotten champion - Gardners boxing legacy
        </p>
      </div>
      <div className='modal-header-right'>
      <button id='modalClose' type="button" class="btn" data-bs-dismiss="modal">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-x-lg-modal" viewBox="0 0 16 16"><path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"></path></svg>
      </button>
      </div>
    </div>
  <div>
  <div className="comment_section">
  <Loader loading={loading} />
    {
      messagedata.map((item, i) => {
        return (
          <div className="mvp-comment-video">
          <div className="video-comments">
            <div><img src="/assets/images/comment-img.jpeg" alt="" /></div>
            <div className="comment-user-name">
              <span>{item.fname} {item.lname}</span>
              <div className="comment-date-time">
                <span>{item.create_date}</span>
                <span className="comment-time"></span>
              </div>
            </div>
            <div className="comment_id"><a>#{item.id}</a></div>
          </div>
          <p>{item.message}</p>
          <div className="comment-submit">
            {/*<a className="comment-btn" href="#">Replay</a>*/}
            <div className='beforeRating' id={"beforerate"+item.id}>
              <a className="comment_arrow like-positive" data-id={item.id}><i className="fa-solid fa-arrow-up" /></a>
              <a className="comment_arrow like-negative" data-id={item.id}><i className="fa-solid fa-arrow-down" /></a>
            </div>
            <div class="js-rating" id={"afterrate"+item.id}>
              <span class="votado voto voto_positivo">0</span>
              <span class="votado voto_negativo">0</span>
            </div>
          </div>
        </div>
        )
      })
    }
  </div>



  <div className="full-comment-section">
    <div className="comment-send">
      <div id="comment_box">
      <h2 id='comment_success_message'></h2>
      <div className="comment-input-section">
      <form method='post' onSubmit={handleSubmit} className='comment-main-form'>
        <textarea id="comment_input" name='message' placeholder="Leave a comment" required></textarea>
        <input type='hidden' name='news_id' id='news_id' />
        <input type='hidden' name='news_type' id='news_type' />
        <input type='hidden' name='comment_type' id='comment_type' />
        <input type='hidden' name='user_id' id='user_id' />
        <div className='submitpost'>
          <button type='submit' className="submit-comment">
          <button type='button' id='initializeComment' onClick={initiateComments}></button>  
          <Loader loading={loading} />
            Publish</button>
        </div>
        </form>
      </div>
      </div>
      <div id='before_comment_box'>
        <Link class="comment-btn" to="/signin" onClick={closeModal}>Login to participate</Link>
      </div>
    </div>
  </div>
</div>


  </div>
</div>
</div>
</div>
  )
};

export default Comments;